import { OrbitControls, Preload, useContextBridge } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import Loading from 'components/Loading';
import Product from 'componentsFor3D/Product';
import ProductList from 'componentsFor3D/ProductList';
import StoryButton from 'componentsFor3D/StoryButton';
import Video from 'componentsFor3D/Video';
import { ControlContext } from 'provider/ControlProvider';
import { Suspense, useContext, useRef } from 'react';
import SceneList from 'assets/data/scenelist.json';

export default function Paranoma() {
  const ContextBridge = useContextBridge(ControlContext);
  const { content, setContent } = useContext(ControlContext);
  const orbit = useRef<any>(null);
  return (
    <>
      <button
        className='absolute top-20 right-5 z-50 text-white text-lg rounded-md p-2 border-2 drop-shadow-md shadow-md'
        onClick={() =>
          setContent({
            index: content.index,
            type: 0,
            url: '',
          })
        }
      >
        Back to Map
      </button>
      <Suspense fallback={<Loading />}>
        <Canvas
          dpr={[1, 1.5]}
          camera={{ position: [0, 0, 0.1], fov: 50, near: 0.001 }}
        >
          <ContextBridge>
            <Product url={SceneList[content.index].vUrl} />
            <StoryButton
              pos={SceneList[content.index].sPos}
              name={SceneList[content.index].storyName}
              scale={SceneList[content.index].sSzie}
              url={SceneList[content.index].sUrl}
            />
            {SceneList[content.index].showProduct && (
              <ProductList orbit={orbit} />
            )}
          </ContextBridge>
          <Preload />
          <OrbitControls ref={orbit} maxDistance={5} enablePan={false} />
          <Video
            name={SceneList[content.index].videoName}
            pos={SceneList[content.index].vPos}
            url={SceneList[content.index].mUrl}
          />
        </Canvas>
      </Suspense>
    </>
  );
}
